<template>

    <div class="container-center" style="padding-bottom:80px;">

        <div class="inviteInfo solid">
            <p :class="[infoData.finvitemethod.charAt(0) === '3' ? 'strategy' : '', 'title']" >{{infoData.fname}}</p>
            <p>发布时间：{{ infoData.fdistributedate }}</p>
        </div>



        <div class="inviteInfo dashed">
            <h5>招标信息</h5>
            <el-row><el-col :span="3">招标单位：</el-col><el-col :span="21">{{ infoData.cfcompanyname }}</el-col></el-row>
            <el-row><el-col :span="3">招标内容：</el-col><el-col :span="21">{{ infoData.finvitecontent }}</el-col></el-row>
        </div>


        <div v-if="!isStrategy" class="inviteInfo dashed">
            <h5>标段信息</h5>
            <div v-if="infoData.segmentList.length == 0" class="no-data-tip"></div>
            <div v-else class="invite-unit" v-for="o in infoData.segmentList" :key="o.fid">
                <el-row><el-col :span="6">标段：</el-col><el-col :span="18">{{ o.fcurprojectname +'-'+ o.fbidnum }}</el-col></el-row>
                <el-row><el-col :span="6">所属项目：</el-col><el-col :span="18">{{ o.fcurprojectname }}</el-col></el-row>
                <el-row>
                    <el-col :span="6">产品及服务：</el-col>
                    <el-col :span="18">
                        <span v-for="oo,index in o.productTypeList" :key="oo.fid">
                            <span v-if="index > 0">、</span>{{ oo.fnameL2 }}
                        </span>
                </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">中标单位：</el-col>
                    <el-col :span="18" class="winner">{{ (o.supplierStockList||[]).joinAt('fnameL2','、') }}</el-col>
                </el-row>
            </div>
        </div>


        <div v-if="isStrategy" class="inviteInfo dashed">
            <h5>中标信息</h5>
            <div v-if="!infoData.supplierStockList" class="no-data-tip"></div>
            <div v-else class="invite-unit">
                <el-row>
                    <el-col :span="6">中标单位：</el-col>
                    <el-col :span="18" class="winner">{{ (infoData.supplierStockList||[]).joinAt('fnameL2','、') }}</el-col>
                </el-row>
            </div>
        </div>


    </div><!--container-center-->


</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_invite.png'
    import filter from '@/filter'

    export default {
        name: "invite-info",
        filters: filter,
        data() {
            return {
                // 参数信息
                fid: this.$route.params.fid,
                supplierId: this.$root.stockId,
                isStrategy: false,

                // 基本信息
                infoData: {
                    finvitemethod: '',
                    segmentList: [{managers:[]}]
                },
            }
        },
        computed: {

        },
        methods: {

        },
        mounted: function() {

            // dev test
            window.ji = this;

            // 获取项目数据
            this.$http.post('rest/api/invite/project/info', {
                projectId: this.fid,
                supplierId: this.supplierId
            }).then((res)=>{
                if(res.data.result) {
                    this.infoData = res.data.value;
                    this.isStrategy = (this.infoData.finvitemethod.charAt(0) == '3')
                    this.$root.navs.push({name:this.infoData.fname,path:''})
                }

            })

        },
        created(){
            this.$root.navs = [{name:'中标公告',path:'/winList'}];
            this.$root.activeIndex = 'win'
            this.$root.headImage.src = banner;
        }
    }


</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';
    .winner{font-weight: bold;font-size:16px;color:var(--cMain);}

    .inviteInfo {font-size: 14px;}

    .inviteInfo.solid {height: 100px;border-bottom: 1px solid #E6E7E6;padding-top: 50px;}
    .inviteInfo.solid > p {margin: 0 0 24px 0;color: #000;font-size: 14px;text-align:center;}
    .inviteInfo.solid > p.title {font-size: 18px;font-weight: bold;}
    .inviteInfo.solid > p.title.strategy::after {content: '战略';display: inline-block;width: 40px;height: 22px;line-height: 22px;text-align: center;font-size: 12px;font-weight: normal;color: #fff;background: var(--cMint);border-radius: 2px;vertical-align: bottom;margin-left: 10px;}
    .inviteInfo.dashed {padding-bottom: 10px;border-bottom: 1px dashed #E6E7E6;}
    .inviteInfo.dashed.segment {margin-bottom:20px;}

    .inviteInfo h5 {color: #252525;font-size: 15px;margin: 16px 0;}
    .inviteInfo h5::before {content: '';display: inline-block;width: 5px;height: 5px;background: var(--cMain);vertical-align: middle;margin: 0 10px;}

    .inviteInfo .el-row {margin-bottom: 12px;}
    .inviteInfo .el-col-3,
    .inviteInfo .el-col-6 {color: #5f5f5f;text-align: right;}


    /* 多标段 */
    .invite-unit {display: inline-block;width: 49%;margin-top: 16px;}

    .btn-theme {width: 120px;margin: 50px 0;}

    .btn-managers {position:absolute;margin-left:1104px;}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/win/Detail.vue